import { PaginaCatalogo } from './pagina-catalogo'

/**
 * As cinco telas de catálogo, cada uma com a permissão que a matriz exige.
 *
 * `pontos-conversao` e `produtos-associados` são **estruturais** — só o
 * Administrador mexe, porque são o eixo dos relatórios de marketing e uma alteração
 * ali reescreve a leitura histórica. `motivos-*` e `tags` são operacionais e o Gestor
 * também gerencia (nota ⁷ de `04-roles §3.6`).
 */

export function PaginaPontosConversao() {
  return (
    <PaginaCatalogo
      catalogo="pontos-conversao"
      titulo="Pontos de conversão"
      descricao="O canal por onde o lead entrou. É a dimensão principal dos relatórios de marketing."
      permissao="CATALOGO_GERENCIAR_ESTRUTURAL"
    />
  )
}

export function PaginaProdutosAssociados() {
  return (
    <PaginaCatalogo
      catalogo="produtos-associados"
      titulo="Produtos associados"
      descricao="O que o lead procura. Usado no cadastro e no registro de interação."
      permissao="CATALOGO_GERENCIAR_ESTRUTURAL"
      temCodigoReferencia
    />
  )
}

export function PaginaMotivosAgendamento() {
  return (
    <PaginaCatalogo
      catalogo="motivos-agendamento"
      titulo="Motivos de agendamento"
      descricao="A cor definida aqui é a cor do evento na grade de agendamentos."
      permissao="CATALOGO_GERENCIAR_OPERACIONAL"
      temCor
      temContabilizar
    />
  )
}

export function PaginaMotivosVendaNaoRealizada() {
  return (
    <PaginaCatalogo
      catalogo="motivos-venda-nao-realizada"
      titulo="Motivos de venda não realizada"
      descricao="Obrigatório ao encerrar um lead como venda não realizada. Alimenta o relatório de perdas."
      permissao="CATALOGO_GERENCIAR_OPERACIONAL"
    />
  )
}

export function PaginaTags() {
  return (
    <PaginaCatalogo
      catalogo="tags"
      titulo="Tags"
      descricao="Marcações livres para recortar leads em campanhas e filtros."
      permissao="CATALOGO_GERENCIAR_OPERACIONAL"
    />
  )
}
